export var E_COLUMN_SEARCH_TYPE;
(function (E_COLUMN_SEARCH_TYPE) {
    E_COLUMN_SEARCH_TYPE["DATE"] = "date";
    E_COLUMN_SEARCH_TYPE["SET"] = "set";
    E_COLUMN_SEARCH_TYPE["TIME_LEFT"] = "time-left";
    E_COLUMN_SEARCH_TYPE["TEXT"] = "text";
    E_COLUMN_SEARCH_TYPE["FULL_NAME"] = "full-name";
    E_COLUMN_SEARCH_TYPE["MULTI_LINE_TEXT"] = "multi-line-text";
})(E_COLUMN_SEARCH_TYPE || (E_COLUMN_SEARCH_TYPE = {}));
export var E_HISTORY_EVENT_TYPE;
(function (E_HISTORY_EVENT_TYPE) {
    E_HISTORY_EVENT_TYPE["SMS"] = "SMS";
    E_HISTORY_EVENT_TYPE["ACCESS"] = "ACCESS";
    E_HISTORY_EVENT_TYPE["EMAIL"] = "EMAIL";
    E_HISTORY_EVENT_TYPE["REFUSED_CASE"] = "REFUSED_CASE";
    E_HISTORY_EVENT_TYPE["ACCEPTED_CASE"] = "ACCEPTED_CASE";
    E_HISTORY_EVENT_TYPE["INCOMPLETE_CASE"] = "INCOMPLETE_CASE";
    E_HISTORY_EVENT_TYPE["CASE_TO_BE_STUDIED"] = "CASE_TO_BE_STUDIED";
    E_HISTORY_EVENT_TYPE["REVERTED_CASE"] = "REVERTED_CASE";
    E_HISTORY_EVENT_TYPE["ASSIGNMENT"] = "ASSIGNMENT";
    E_HISTORY_EVENT_TYPE["KYC"] = "KYC";
    E_HISTORY_EVENT_TYPE["WITHDRAWN_CASE"] = "WITHDRAWN_CASE";
    E_HISTORY_EVENT_TYPE["FINALIZED_CASE"] = "FINALIZED_CASE";
    E_HISTORY_EVENT_TYPE["IDENTITY_STATUS_UPDATE"] = "IDENTITY_STATUS_UPDATE";
    E_HISTORY_EVENT_TYPE["SIGNATURE"] = "SIGNATURE";
    E_HISTORY_EVENT_TYPE["APPLICANT_UPDATE"] = "APPLICANT_UPDATE";
    E_HISTORY_EVENT_TYPE["CASE_UPDATE"] = "CASE_UPDATE";
})(E_HISTORY_EVENT_TYPE || (E_HISTORY_EVENT_TYPE = {}));
export var E_IDENTITY_VISIBLE_FIELDS;
(function (E_IDENTITY_VISIBLE_FIELDS) {
    E_IDENTITY_VISIBLE_FIELDS["HONORIFIC_PREFIX"] = "honorificPrefix";
    E_IDENTITY_VISIBLE_FIELDS["GENDER"] = "gender";
    E_IDENTITY_VISIBLE_FIELDS["GIVEN_NAME"] = "givenName";
    E_IDENTITY_VISIBLE_FIELDS["GIVEN_NAME2"] = "givenName2";
    E_IDENTITY_VISIBLE_FIELDS["GIVEN_NAME3"] = "givenName3";
    E_IDENTITY_VISIBLE_FIELDS["FAMILY_NAME"] = "familyName";
    E_IDENTITY_VISIBLE_FIELDS["BIRTH_NAME"] = "birthName";
    E_IDENTITY_VISIBLE_FIELDS["BIRTH_DATE"] = "birthDate";
    E_IDENTITY_VISIBLE_FIELDS["BIRTH_PLACE"] = "birthPlace.name";
    E_IDENTITY_VISIBLE_FIELDS["NATIONALITY"] = "nationality.identifier";
    E_IDENTITY_VISIBLE_FIELDS["STREET_ADDRESS"] = "address.streetAddress";
    E_IDENTITY_VISIBLE_FIELDS["POSTAL_CODE"] = "address.postalCode";
    E_IDENTITY_VISIBLE_FIELDS["ADDRESS_LOCALITY"] = "address.addressLocality";
    E_IDENTITY_VISIBLE_FIELDS["ADDRESS_REGION"] = "address.addressRegion";
    E_IDENTITY_VISIBLE_FIELDS["ADDRESS_COUNTRY"] = "address.addressCountry";
    E_IDENTITY_VISIBLE_FIELDS["TELEPHONE"] = "telephone";
    E_IDENTITY_VISIBLE_FIELDS["EMAIL"] = "email";
    E_IDENTITY_VISIBLE_FIELDS["PERSONAL_ID"] = "personalId";
    E_IDENTITY_VISIBLE_FIELDS["MONTHLY_NET_INCOME"] = "monthlyNetIncome";
    E_IDENTITY_VISIBLE_FIELDS["DOCUMENT_NUMBER"] = "identityDocument.documentNumber";
    E_IDENTITY_VISIBLE_FIELDS["MRZ_LINES"] = "identityDocument.mrzLines";
    E_IDENTITY_VISIBLE_FIELDS["EXPIRATION_DATE"] = "identityDocument.expirationDate";
})(E_IDENTITY_VISIBLE_FIELDS || (E_IDENTITY_VISIBLE_FIELDS = {}));
export var E_CASE_UPDATE_TRANSLATED_FIELDS;
(function (E_CASE_UPDATE_TRANSLATED_FIELDS) {
    E_CASE_UPDATE_TRANSLATED_FIELDS["CASE_CLIENT_ID"] = "caseClientId";
})(E_CASE_UPDATE_TRANSLATED_FIELDS || (E_CASE_UPDATE_TRANSLATED_FIELDS = {}));
